<template>
    <div v-if="ALERT.show">
        <p class="ma-0 d-flex align-center" v-if="ALERT.type === 1">
            <svg v-svg="'icon-alert-success'" size="24" class="mr-2"></svg>
            <span class="success-alert">Success!</span>
        </p>

        <p class="ma-0 d-flex align-center" v-else-if="ALERT.type === 2">
            <svg v-svg="'icon-alert-error'" size="24" class="mr-2"></svg>
            <span class="error-alert">Error</span>
        </p>

        <p class="ma-0 d-flex align-center" v-else-if="ALERT.type === 3">
            <svg v-svg="'icon-alert-info'" size="24" class="mr-2"></svg>
            <span class="info-alert">Info</span>
        </p>

        <p class="ma-0 d-flex align-center" v-else-if="ALERT.type === 4">
            <svg v-svg="'icon-alert-warning'" size="24" class="mr-2"></svg>
            <span class="warning-alert">Warning</span>
        </p>

        <span class="mx-5 text-center">{{ALERT.message}}</span>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        computed: mapGetters(['ALERT'])
    }
</script>

<style scoped>
    div{
        width: 345px;
        height: 100px;
        background: #FFFFFF 0 0 no-repeat padding-box;
        box-shadow: 0 3px 5px #5A5A5A73;
        border-radius: 17px;
        position: fixed;
        bottom: 16px;
        right: 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        animation-name: hide;
        animation-duration: 10s;
    }

    @keyframes hide {
        from {opacity: 1}
        to {opacity: 0}
    }

    div::after{
        content: '';
        width: 0;
        height: 0;
        border-top: 15px solid transparent;
        border-left: 30px solid white;
        border-bottom: 15px solid transparent;
        transform: rotate(33deg);
        position: absolute;
        bottom: -10px;
        right: -16px;
        filter: drop-shadow(5px 2px 4px #5A5A5A73);
    }

    p span{
        font-size: 20px;
        font-weight: bold;
        cursor: default;
    }

    .success-alert{
        color: #5BB235;
    }

    .error-alert{
        color: #BF0000;
    }

    .info-alert{
        color: #0054C1;
    }

    .warning-alert{
        color: #C17400;
    }

    div > span{
        font-size: 14px;
        font-weight: bold;
        cursor: default;
    }
</style>